/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useCallback } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { getBase64Url } from "../utilFunctions";
import { IMAGE_TYPE } from "../consts";
import { Controlled as ControlledZoom } from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const ViewImagePopup = ({ isOpen, toggle, index, allImages, imageType }) => {
  const [base64Image, setBase64Image] = useState(null);
  const [imageText, setImageText] = useState("View Image");
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [isLoading, setLoading] = useState(false);
  const [imageURL, setImageURL] = useState("");
  const [isZoomed, setIsZoomed] = useState(false);

  const loadImage = async (selectedIndex) => {
    if (allImages?.length && imageType === IMAGE_TYPE.FIELD_SURVEY) {
      setLoading(true);
      const jsonResponse = await getBase64Url(allImages[selectedIndex].name);
      setBase64Image(`data:image/jpeg;base64,${jsonResponse.response}`);
      setImageText(allImages[selectedIndex].imageText);
    } else if (allImages?.length && imageType === IMAGE_TYPE.CLAIM_FORM) {
      setLoading(true);
      setImageURL(allImages[selectedIndex]?.url);
      const title = allImages[selectedIndex]?.name || "";
      setImageText(title.split("_")[0]);
    }
  };

  const handleZoomChange = useCallback((shouldZoom) => {
    setIsZoomed(shouldZoom);
  }, []);
  useEffect(() => {
    if (allImages && allImages?.length && index !== undefined) {
      setCurrentIndex(index);
      setBase64Image(null);
      loadImage(index);
    }
  }, [allImages, index]);

  const previousImage = () => {
    if (!isLoading && currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      loadImage(newIndex);
    }
  };
  const nextImage = () => {
    if (!isLoading && currentIndex < allImages.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      loadImage(newIndex);
    }
  };

  return (
    <div>
      <Modal
        show={isOpen}
        onHide={toggle}
        backdrop="static"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="preview-modal-dialog"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="view-image-title">{imageText || "View Image"}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="gis-modal-body">
          <div className="preview_image_parent">
            <ControlledZoom isZoomed={isZoomed} onZoomChange={handleZoomChange}>
              <img
                src={
                  imageType === IMAGE_TYPE.FIELD_SURVEY && base64Image
                    ? base64Image
                    : imageURL
                }
                onLoad={() => {
                  setLoading(false);
                }}
              />
            </ControlledZoom>
          </div>
          {isLoading && imageType === IMAGE_TYPE.FIELD_SURVEY && (
            <div className="d-flex justify-content-center  preview-loader">
              <Spinner animation="border" />
            </div>
          )}
          {isLoading && imageType === IMAGE_TYPE.CLAIM_FORM && (
            <div className="d-flex justify-content-center preview-loader">
              <Spinner animation="border" />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <div className="me-2">
              <div
                className={`previous ${currentIndex <= 0 ? "disabled" : ""}`}
                onClick={previousImage}
              >
                <i className="fa fa-angle-left"></i>
              </div>
              <div
                className={`next ${
                  currentIndex >= allImages?.length - 1 ? "disabled" : ""
                } `}
                onClick={nextImage}
              >
                <i className="fa fa-angle-right"></i>
              </div>
            </div>

            <Button variant="primary" onClick={toggle}>
              OK
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewImagePopup;
